import type { JSX } from 'react'
import type { ITabsContainerProps } from '../TabsContainer'

import { usePinnedBarBackground, useSSRLazyLoading } from 'utils/hooks'
import { TabsContainer } from '../TabsContainer'
import { TabControlsType } from '../TabsContainer.h'

export interface IPinnedTabsInlineControls extends Omit<
  ITabsContainerProps,
  'backgroundColor'
> {}

export const PinnedTabsInlineControls = ({
  children,
  controlsType = TabControlsType.inRow,
  ...rest
}: IPinnedTabsInlineControls): JSX.Element | null => {
  const isShowComponent = useSSRLazyLoading()
  const backgroundColor = usePinnedBarBackground()

  return isShowComponent ? (
    <TabsContainer
      controlsType={controlsType}
      {...rest}
      backgroundColor={backgroundColor}
    >
      {children}
    </TabsContainer>
  ) : null
}
